import { Controller } from "@hotwired/stimulus";
import { rrFetch } from "../utils/rr_fetch"

export default class extends Controller {
    static targets = [
        "findBestRouteButton",
        "findBestRouteButtonText",
        "goBackButton",
        "goBackButtonText",
        "loadingSpinner",
        "errorMessage",
    ];

    static values = {
        redirectlink: String,
        orderid: String,  
        csrftoken: String,
    };

    connect() {}

    async handleRedirectToHoudini(e) {
        const redirectLink = this.redirectlinkValue;
        const orderId = this.orderidValue;
        const csrfToken = this.csrftokenValue;

        try {
            window.open(redirectLink, "_blank");
      
            const response = await rrFetch("/deposit/crypto/order-status", {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                "X-CSRF-Token": csrfToken,
              },
              body: JSON.stringify({
                orderId,
              }),
            });


          } catch (error) {
            console.error("Error happened during find best route", error);
            this.errorMessageTarget.textContent =
              "Error happened during find best route";
          }
    }

    showLoadingSpinner() {
        this.findBestRouteButtonTarget.disabled = true;
        this.loadingSpinnerTarget.classList.remove("hidden");
        this.findBestRouteButtonTextTarget.textContent = "Awaiting deposit...";
    }
}